import { createTheme } from '@mui/material';
export const theme = createTheme({
    typography: { fontFamily: 'Inter, sans-serif' },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@global': { body: { fontFamily: 'Inter, sans-serif', fontWeight: 400 } },
            },
        },
    },
});
